import React, { useCallback } from 'react';

import { Typography } from '@material-ui/core';
import { Pagination, Skeleton } from '@material-ui/lab';

import useStyles from './styles';

interface PaginationProps {
  pageCount: number;
  paginationDescribe: string;
  totalRows: number;
  actualPage: number;
  onPageChange(newPage: number): void;
  paginationAlignment?: string;
  paginationPosition?: string;
  loading?: boolean;
}

const CustomPagination: React.FC<PaginationProps> = props => {
  const classes = useStyles(props);
  const {
    pageCount,
    paginationDescribe,
    totalRows,
    actualPage,
    onPageChange,
    loading,
  } = props;

  const handlePagination = useCallback(
    (_: any, newPage: number) => {
      if (newPage !== actualPage) {
        onPageChange(newPage);
      }
    },
    [actualPage, onPageChange],
  );

  return (
    <div className={classes.paginationContainer}>
      {loading ? (
        <Skeleton
          className={classes.skeleton}
          height={24}
          width={180}
          animation="wave"
        />
      ) : (
        <>
          <Typography className={classes.paginationDataLabel}>
            {paginationDescribe}
          </Typography>
          <Typography
            className={classes.paginationDataLabel}
            style={{ marginRight: 0 }}
          >
            &nbsp; de &nbsp;
          </Typography>
          <Typography className={classes.paginationDataLabel}>
            {totalRows} linha{totalRows > 1 ? 's' : ''}
          </Typography>
        </>
      )}
      <Pagination
        count={pageCount}
        page={actualPage}
        shape="rounded"
        color="primary"
        onChange={handlePagination}
        disabled={loading}
        showFirstButton
        showLastButton
      />
    </div>
  );
};

export default CustomPagination;
